import request from "utils/request";

export async function addProject(payload) {
	return request("/rest/project", {
		method: "PUT",
		body: payload
	});
}

export async function deleteProjects(payload) {
	return request("/rest/projects/" + payload.campaignId, {
		method: "DELETE",
		body: payload.ids
	});
}

export async function renameProject(projectId, payload) {
  return request("/rest/project/rename/" + projectId, {
    method: "POST",
    body: payload
  })
}

export async function duplicateProject(projectId, payload) {
	return request("/action/duplicate/project/" + projectId, {
    method: "POST",
    body: payload
  })
}